import { cloneDeep, isNil } from 'lodash';
import { useCallback } from 'react';
import { getLatestWorkflowTemplate, isSubformComponent } from '../utils';
import { useUpdateWorkflowTemplate } from './useUpdateWorkflowTemplate';

export function useUpdateSubformComponentWorkflows(
  workflowTemplateId?: string,
  subformComponentId?: string,
) {
  const [updateWorkflow] = useUpdateWorkflowTemplate();

  return useCallback(
    async (newWorkflowTemplateId?: string) => {
      if (isNil(workflowTemplateId) || isNil(newWorkflowTemplateId)) {
        return;
      }
      const { workflowTemplate } = await getLatestWorkflowTemplate(workflowTemplateId);

      const updatedWorkflowTemplate = cloneDeep(workflowTemplate);
      if (!isNil(updatedWorkflowTemplate) && !isNil(subformComponentId)) {
        addWorkflowToSubformComponent(
          updatedWorkflowTemplate,
          subformComponentId,
          newWorkflowTemplateId,
        );
      }
      if (!isNil(updatedWorkflowTemplate)) {
        await updateWorkflow(updatedWorkflowTemplate);
      }
    },
    [subformComponentId, updateWorkflow, workflowTemplateId],
  );
}

function addWorkflowToSubformComponent(
  workflowTemplate: MBAPI.WorkflowTemplate,
  subformComponentId: string,
  newWorkflowTemplateId: string,
): void {
  for (const component of workflowTemplate.components) {
    if (isSubformComponent(component) && subformComponentId === component.id) {
      component.workflowTemplateIds = component.workflowTemplateIds.concat(newWorkflowTemplateId);
      break;
    }
  }
}
